import React from 'react';
import { MenuItem } from '@types';

const menuItems: MenuItem[] = [
  {
    id: '1',
    name: 'Stew Tilapia/Coalfish',
    description: 'Radish, Corn, Mushroom Eggplant',
    price: 66,
    badge: 'seasonal',
    image: '/assets/images/menu-1-1.png',
    category: 'stew',
  },
  {
    id: '2',
    name: 'Pickle Cabbage Stewed with Pork',
    description: 'Including Chinese Sauerkraut, Pork Rib, Pork Belly, Frozen Tofu',
    price: 58,
    image: '/assets/images/menu-2-2.png',
    category: 'stew',
  },
  {
    id: '3',
    name: 'Stew Lamb Spine',
    description: 'Including Lamb Spine, Chinese Cabbage, White Radish 含羊蝎子，白菜，白萝卜。',
    price: 58,
    image: '/assets/images/menu-3-3.png',
    category: 'stew',
  },
  {
    id: '4',
    name: 'Stew Tendon and Brains',
    description: 'Beef Brisket, Beef Tendon, Osso Buco, Potatoes, Carrots & Corn',
    price: 68,
    badge: 'new',
    image: '/assets/images/menu-4-4.png',
    category: 'stew',
  },
  {
    id: '5',
    name: 'Stew Goose',
    description: 'Including Chinese cabbage. Potato, Corn, Goose',
    price: 76,
    image: '/assets/images/menu-5-5.png',
    category: 'stew',
  },
  {
    id: '6',
    name: 'Chicken Stewed with Mushrooms',
    description: 'Including free run chicken, Mushroom, Potato, Flower',
    price: 58,
    image: '/assets/images/menu-6.png',
    category: 'stew',
  },
];

const MenuSection: React.FC = () => {
  return (
    <section className="section menu" aria-label="menu-label" id="menu">
      <div className="container">
        <p className="section-subtitle text-center label-2">
          Best Northeastern Dish in 626 Area
        </p>

        <h2 className="headline-1 section-title text-center">
          Iron-Stew Pot Menu - Los Angeles
        </h2>

        <ul className="grid-list">
          {menuItems.map((item) => (
            <li key={item.id}>
              <div className="menu-card hover:card">
                <figure
                  className="card-banner img-holder"
                  style={{ '--width': '100', '--height': '100' } as React.CSSProperties}
                >
                  <img
                    src={item.image}
                    width="100"
                    height="100"
                    loading="lazy"
                    alt={item.name}
                    className="img-cover"
                  />
                </figure>

                <div>
                  <div className="title-wrapper">
                    <h3 className="title-3">
                      <a href="#" className="card-title">
                        {item.name}
                      </a>
                    </h3>

                    {item.badge && (
                      <span className="badge label-1">{item.badge}</span>
                    )}

                    <span className="span title-2">${item.price}</span>
                  </div>

                  <p className="card-text label-1">{item.description}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>

        <p className="menu-text text-center">
          During winter daily from <span className="span">7:00 pm</span> to{' '}
          <span className="span">9:00 pm</span>
        </p>

        <a
          href="https://happy-valley-village.res-menu.com/menu"
          className="btn btn-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text text-1">View All Menu</span>
          <span className="text text-2" aria-hidden="true">
            View All Menu
          </span>
        </a>

        <img
          src="/assets/images/shape-5.png"
          width="921"
          height="1036"
          loading="lazy"
          alt="shape"
          className="shape shape-2 move-anim"
        />
        <img
          src="/assets/images/shape-6.png"
          width="343"
          height="345"
          loading="lazy"
          alt="shape"
          className="shape shape-3 move-anim"
        />
      </div>
    </section>
  );
};

export default MenuSection;
